import React from 'react';
import { ComposableMap, Geographies, Geography } from 'react-simple-maps';
import styles from './MapChart.module.css';

const geoUrl = 'https://cdn.jsdelivr.net/npm/us-atlas@3/states-10m.json';

const AdminMapChart = ({ stateData, onToggleState }) => {
    const safeStateData = Array.isArray(stateData) ? stateData : [];

    const handleClick = (stateName) => {
        const match = safeStateData.find((state) => state?.stateName === stateName);
        if (!match || !onToggleState) {
            return;
        }
        onToggleState(match.stateCode);
    };

    const availableStates = safeStateData.filter((state) => state && state.available).length;

    return (
        <div className={styles.mapWrapper}>
            <div className={styles.mapContainer}>
                <ComposableMap
                    projection="geoAlbersUsa"
                    projectionConfig={{
                        scale: 1000,
                        center: [0, 0]
                    }}
                    style={{
                        width: '100%',
                        height: '100%'
                    }}
                >
                    <Geographies geography={geoUrl}>
                        {({ geographies }) =>
                            geographies.map((geo) => {
                                const stateName = geo.properties.name;
                                const stateInfo = safeStateData.find(
                                    (state) => state?.stateName === stateName
                                );
                                const available = stateInfo ? stateInfo.available : false;

                                return (
                                    <Geography
                                        key={geo.rsmKey}
                                        geography={geo}
                                        strokeWidth={0.5}
                                        style={{
                                            /* SVG fill/stroke attributes can't resolve var(); use inline styles */
                                            default: {
                                                fill: available ? 'var(--sm-map-available)' : 'var(--sm-map-unavailable)',
                                                stroke: 'var(--sm-map-stroke)',
                                                outline: 'none'
                                            },
                                            hover: {
                                                fill: available ? 'var(--sm-map-available-hover)' : 'var(--sm-map-unavailable-hover)',
                                                stroke: 'var(--sm-map-stroke)',
                                                outline: 'none',
                                                cursor: 'pointer'
                                            },
                                            pressed: {
                                                fill: available ? 'var(--sm-map-available)' : 'var(--sm-map-unavailable)',
                                                stroke: 'var(--sm-map-stroke)',
                                                outline: 'none'
                                            }
                                        }}
                                        onClick={() => handleClick(stateName)}
                                        title={`${stateName}: ${available ? 'Available' : 'Not Available'}`}
                                    />
                                );
                            })
                        }
                    </Geographies>
                </ComposableMap>
            </div>

            <div className={styles.legend}>
                <div className={styles.legendItem}>
                    <div className={styles.legendColor} style={{ backgroundColor: 'var(--sm-map-available)' }}></div>
                    <span>Available</span>
                </div>
                <div className={styles.legendItem}>
                    <div className={styles.legendColor} style={{ backgroundColor: 'var(--sm-map-unavailable)' }}></div>
                    <span>Unavailable</span>
                </div>
            </div>

            <div className={styles.statsSection}>
                Available in {availableStates} {availableStates === 1 ? 'state' : 'states'}
            </div>
        </div>
    );
};

export default AdminMapChart;
